import React from 'react';

import QuotaZonal  from 'components/Tvendo/Sale/QuotaBPartner/Verdum/QuotaZonal/List.js';

export default function () {
  return <QuotaZonal  />;
}